<template>
  <div class="question" v-bind:class="{ 'text-center': model.answers.length === 0 }">
    <p v-if="model.required_error" class="message-error message" style="">{{ $t("ui.requiredError") }}</p>
    <p v-if="model.email_error" class="message-error message" style="">{{ $t("ui.emailError") }}</p>
    <div class="question-title" v-html="checkReplaces(model)"></div>
    <div class="question-description" v-html="model.description"></div>
    <div class="question-body">
      <answer @answerClick="questionFill"
              @checkDependency="checkDependency"
              :question="model"></answer>
    </div>
  </div>
</template>

<script>
import Answer from '../ui/Answer'

export default {
  name: 'question',
  props: ['model', 'replaces'],
  data() {
    return {
      answers: []
    }
  },
  methods: {
    questionFill: function () {
      if (this.model.is_required) {
        this.$emit("questionFill", this.model.uid);
      }
    },
    checkDependency: function (answer_uid) {
      this.$emit("checkDependency", answer_uid);
    },
    checkReplaces: function (model) {
      this.replaces.forEach((item) => {
        model.title = model.title.replace(item.type, item.value);
      })
      return model.title;
    },
  },
  components: {
    Answer
  }
}
</script>
